
import classnames from 'classnames';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setDarkTitleCurrentCase } from '../../../layouts/actions/actionCreator';
// utils
import { setElementAttributes, Translations } from '../../../../utils';
// constant
import { FORM_REFS } from '../../../../constants';
// restClient
import { eapiClient } from '../../../../restClient';
// children
import Dynamicform from '../../../common/Dynamicform/dynamicForm';

import { electOwningCase } from '../../../../utils';
import { newManualCase } from '../../actions/actionCreator';
//style
//import './CustomerDetails.css';

class BasicDetails extends Component {

  constructor(props) {
    super(props);
    this.state = {
      formData: {},
      caseId: '',
      registeredName: '',
      formDisabled: true,
      CaseRecordToggle: false,
      CreateNewToggle: false,
      serviceHistory: [],
      errMsg: undefined,
      flag: undefined,
      resetData: false,
      ResetForm: false,
      formRandomIdx: null
    };
  }

  componentWillMount() {
    if (this.props.owningCase !== undefined) {
      console.log("new manual case", this.props.case);
      var entityId = this.props.case !== undefined && this.props.case.entityId !== undefined ? this.props.case.entityId : this.props.case.id;
      eapiClient('/entities/organisations/' + entityId + '?caseId=' + this.props.case.caseId)
        .then(({ data: { responseData } }) => {
          if (responseData !== undefined) {
            var entityData = responseData;
            entityData['CaseRecordType'] = this.props.case.CaseRecordType;
            eapiClient('/cases/' + this.props.case.caseId + '/migration')
              .then(({ data: { responseData } }) => {
                Array.prototype.slice.call(document.getElementsByName('CaseRecordType')).forEach(i => i.disabled = true);
                var caseData = responseData;
                if (caseData.msa2011Case) {
                  this.props.setTabEnabled(3)
                  this.props.handleMsaCases(true)
                } else {
                  this.props.handleMsaCases(false)
                }

                this.props.setDarkTitleCurrentCase(caseData);
                this.setState({
                  currentCase: this.getBasicDetailsData(entityData, caseData),
                  entityId: entityData.id,
                  errMsg: false,
                  flag: Math.random(),
                  formDisabled: this.props.isTnC ? true : false,
                  searchBoxDisabled: true,
                  resetData: !this.state.resetData,
                })
                // console.log('##### currentCase', this.state.currentCase);
              })
            eapiClient('/cases/organisations/' + entityId + '/clientsphere-cases')
              .then(({ data, status }) => {
                let history = data.responseData;
                history.forEach(row => {
                  row['caseOwner'] = row['caseOwner'].name
                });
                this.setState({ serviceHistory: Array.isArray(history) ? history : [] })
              });
          }
        })
      if (document.getElementById("manual-case-reset-button")) {
        setElementAttributes(document.getElementById("manual-case-reset-button"), { remove: ["disabled"] })
      }
    }
    else {
      if (document.getElementById("manual-case-reset-button")) {
        setElementAttributes(document.getElementById("manual-case-reset-button"), { disabled: "disabled" })
      }
    }
  }


  getFormData = (formData) => {
    if (formData.glcmImplementation !== undefined && formData.glcmImplementation === false) {
      formData.projectNo = '';
      formData.csProjectNumber = '';
      formData.cmpProjectID = '';
      //delete formData['csProjectNumber'];
    }
    this.setState({
      formData,
      reload: false
    });
  }

  onFormBasicDetail = (event, apiURL) => {
    var requestData = {};
    let _csProjectNumber = '';
    let _cmpProjectID = '';
    var entityId = this.state.entityId;

    if (this.state.formData.csProjectNumber !== '' && this.state.formData.csProjectNumber !== undefined) {
      _csProjectNumber = 'PRJ_' + this.state.formData.csProjectNumber
    }

    if (this.state.formData.cmpProjectID !== '' && this.state.formData.cmpProjectID !== undefined) {
      _cmpProjectID = 'P' + this.state.formData.cmpProjectID
    }

    if (entityId !== undefined) {
      requestData = {
        msa2011Case: this.props.msaCases,
        basicDetails: {
          lid: this.state.currentCase.lid, id: this.state.currentCase.id,
          entityId: this.state.entityId,
          caseId: this.state.currentCase.caseId,
          registeredName: this.state.formData["registeredName"],
          countryOfIncorporation: this.state.formData["countryOfIncorporation"],
          countryOfRegistration: this.state.formData["countryOfRegistration"],
          businessSegment: this.state.formData["businessSegment"],
          gdocsTerms: this.state.formData["GdocsTerms"].value,
          glcmImplementation: this.state.formData["glcmImplementation"],
          projectNo: this.state.formData["projectNo"] || '',
          csProjectNumber: _csProjectNumber,
          cmpProjectID: _cmpProjectID,
          financialInstitution: this.state.formData["financialInstitution"],
          txtGRIDno: this.state.formData["txtGRIDno"]
        }
      }
    } else {
      requestData = {
        registeredName: this.state.formData["registeredName"],
        countryOfIncorporation: this.state.formData["countryOfIncorporation"],
        countryOfRegistration: this.state.formData["countryOfRegistration"],
        businessSegment: this.state.formData["businessSegment"],
        glcmImplementation: this.state.formData["glcmImplementation"],
        projectNo: this.state.formData["projectNo"] || '',
        csProjectNumber: _csProjectNumber,
        cmpProjectID: _cmpProjectID,
        gdocsTerms: this.state.formData["GdocsTerms"].value,
        financialInstitution: this.state.formData["financialInstitution"],
        txtGRIDno: this.state.formData["txtGRIDno"],
        msa2011Case: this.props.msaCases
      }
    }

    var METHOD = this.state.currentCase !== undefined ? this.state.currentCase.caseId !== undefined ? 'PUT' : 'POST' : 'POST';

    var URL = this.translations(apiURL);
    if (METHOD === 'PUT') {
      URL = URL + '/' + entityId;
    }
    if (METHOD === 'POST' && this.state.currentCase !== undefined) {
      URL = '/cases/' + this.state.formData["CaseID"] + '/organisations/' + entityId
    }
    console.log(JSON.stringify(requestData))
    eapiClient(URL, {
      method: METHOD,
      data: JSON.stringify(requestData)
    })
      .then(({ data }) => {
        var caseData;
        if (METHOD === 'POST' && this.state.currentCase === undefined) {
          var url = '/cases/' + this.state.formData["CaseID"] + '/organisations/' + data.responseData.id;
          eapiClient(url, {
            method: METHOD,
            data: JSON.stringify(requestData)
          })
            .then(({ data: { responseData } }) => {
              requestData = {
                basicDetails: {
                  lid: responseData.lid, id: responseData.id,
                  entityId: data.responseData.id,
                  caseId: responseData.id,
                  ...requestData
                }
              }
              eapiClient(this.translations(apiURL) + '/' + data.responseData.id, {
                method: "PUT",
                data: JSON.stringify(requestData)
              });
              caseData = data.responseData;
              caseData['caseId'] = responseData.id;
              caseData['caseNum'] = responseData.caseId;
              caseData['caseDetails'] = responseData;
              caseData['CaseRecordType'] = this.state.formData["CaseRecordType"] !== undefined ? this.state.formData["CaseRecordType"] : this.props.case.CaseRecordType;
              this.props.newManualCase(caseData)
              this.props.msaCases ? this.props.setTabActive(2) : this.props.setTabActive(1)
              this.props.msaCases ? this.props.setTabEnabled(3) : this.props.setTabEnabled(2)
              this.props.setDarkTitleCurrentCase(caseData.caseDetails);
            })
        } else if (METHOD === 'POST' && this.state.currentCase !== undefined) {
          requestData = {
            ...requestData,
            caseId: data.responseData.id
          }
          eapiClient(this.translations(apiURL) + '/' + entityId, {
            method: "PUT",
            data: JSON.stringify(requestData)
          }).then(({ data: { responseData } }) => {
            caseData = responseData;
            caseData['entityId'] = entityId;
            caseData['caseNum'] = this.state.formData["CaseID"];
            caseData['caseDetails'] = data.responseData;
            caseData['caseId'] = this.state.currentCase.caseId !== undefined ? this.state.currentCase.caseId : data.responseData.id;
            caseData['CaseRecordType'] = this.state.formData["CaseRecordType"] !== undefined ? this.state.formData["CaseRecordType"] : this.props.case.CaseRecordType;
            this.props.newManualCase(caseData)
            this.props.msaCases ? this.props.setTabActive(2) : this.props.setTabActive(1)
            this.props.msaCases ? this.props.setTabEnabled(3) : this.props.setTabEnabled(2)
            this.props.setDarkTitleCurrentCase(caseData.caseDetails);
          })
        } else {
          caseData = data.responseData;
          caseData['entityId'] = entityId;
          caseData['caseNum'] = this.state.formData["CaseID"];
          caseData['caseId'] = this.state.currentCase.caseId !== undefined ? this.state.currentCase.caseId : data.responseData.id;
          caseData['CaseRecordType'] = this.state.formData["CaseRecordType"] !== undefined ? this.state.formData["CaseRecordType"] : this.props.case.CaseRecordType;
          this.props.newManualCase(caseData)
          this.props.msaCases ? this.props.setTabActive(2) : this.props.setTabActive(1)
          this.props.msaCases ? this.props.setTabEnabled(3) : this.props.setTabEnabled(2)
        }

      })
  }

  resetCaseID = () => {
    this.setState({
      CaseRecordToggle: !this.state.CaseRecordToggle,
      currentCase: undefined,
      entityId: undefined,
      formDisabled: true,
      gdocsTerms: ""
    })
  }

  _onCheckAvailability = () => {
    if (this.state !== undefined && this.state.formData !== undefined && this.state.formData.CaseID !== undefined) {
      eapiClient(`/cases/${this.state.formData.CaseID}/case-details`, {
        method: 'GET',
      }).then(({ data, response }) => {
        this.setState({
          flag: Math.random(),
          errMsg: true
        })
        document.getElementById('searchText').readOnly = true;
      }).catch(({ response }) => {
        console.log('ERROR:', response);
        if (response.status === 404) {
          this.setState({
            errMsg: false,
            flag: Math.random(),

          })
          // document.getElementById('CaseIDField').childNodes[1].childNodes[0].childNodes[0].disabled = true;
          if (document.getElementById('CaseID' + this.state.formRandomIdx)) {
            setElementAttributes(document.getElementById('CaseID' + this.state.formRandomIdx), { disabled: true })
          }
          if (document.getElementById("manual_case-msa_2011")) {
            setElementAttributes(document.getElementById("manual_case-msa_2011"), { disabled: true })
          }
          if (document.getElementById("manual-case-reset-button")) {
            setElementAttributes(document.getElementById("manual-case-reset-button"), { remove: ["disabled"] })
          }

          document.getElementById('searchText').removeAttribute("readonly");
          Array.prototype.slice.call(document.getElementsByName('CaseRecordType')).forEach(i => i.disabled = true);
        }
      })
    }
  }

  _onSearch = () => {
    if (this.state !== undefined && this.state.formData !== undefined && this.state.formData.CaseID !== undefined) {
      eapiClient(`/cases/${this.state.formData.CaseID}/clientsphere-cases`)
        .then(({ data }) => {
          this.props.newManualCase(data.responseData)
          this.setState({
            currentCase: this._getFormData(data.responseData),
            entityId: data.responseData.id,
            errMsg: false,
            flag: Math.random(),
            formDisabled: false,
            gdocsTerms: "urn:hsbc:cmb:gdocs:cases:taxonomies:csGdocsTerms:negotiated",
            resetData: !this.state.resetData,
          })
          Array.prototype.slice.call(document.getElementsByName('CaseRecordType')).forEach(i => i.disabled = true);

          // document.getElementById('CaseIDField').childNodes[1].childNodes[0].childNodes[0].disabled = true;
          if (document.getElementById('CaseID' + this.state.formRandomIdx)) {
            setElementAttributes(document.getElementById('CaseID' + this.state.formRandomIdx), { disabled: true })
          }
          if (document.getElementById("manual_case-msa_2011")) {
            setElementAttributes(document.getElementById("manual_case-msa_2011"), { disabled: true })
          }
          if (document.getElementById("manual-case-reset-button")) {
            setElementAttributes(document.getElementById("manual-case-reset-button"), { remove: ["disabled"] })
          }

          eapiClient('/cases/' + data.responseData.caseId + '/migration')
            .then(({ data: { responseData } }) => {
              this.props.setDarkTitleCurrentCase(responseData);
              if (responseData.msa2011Case) {
                this.props.setTabEnabled(3)
                this.props.handleMsaCases(true)
              } else {
                this.props.handleMsaCases(false)
              }
            })

          eapiClient('/cases/organisations/' + data.responseData.id + '/clientsphere-cases', {
            timeout: 1200000
          })
            .then(({ data, status }) => {
              let history = data.responseData;
              history.forEach(row => {
                row['caseOwner'] = row['caseOwner'].name
              });
              this.setState({ serviceHistory: Array.isArray(history) ? history : [] })
            });

        }).catch(({ response }) => {
          console.log('ERROR:', response);
          if (response.status === 404) {
            this.setState({
              errMsg: true,
              flag: Math.random(),
              formDisabled: true
            })
          }
        })
    }
  }

  _onReset = () => {
    this.props.disableActiveTabs();
    Array.prototype.slice.call(document.getElementsByName('CaseRecordType')).forEach(i => i.disabled = false);
    this.setState({
      formDisabled: true,
      formData: {},
      currentCase: undefined,
      entityId: undefined,
      ResetForm: !this.state.ResetForm,
      serviceHistory: []
    })
    this.props.handleMsaCases(false)
    setElementAttributes("manual_case-msa_2011", { disabled: true })
    setElementAttributes("CaseID" + this.state.formRandomIdx, { disabled: true })
  }


  _getFormData = (data) => {
    if (data !== undefined) {
      var projectId = data['csProjectNumber'] !== undefined ? data['csProjectNumber'].split('_') : '';
      if (projectId !== undefined) {
        data['csProjectNumber'] = projectId[1];
        data['CaseRecordType'] = this.state.formData.CaseRecordType;
      }
      if (data["cmpProjectID"]) {
        data["cmpProjectID"] = data["cmpProjectID"].split("P")[1]
      }

      return data;
    }
  }

  getBasicDetailsData = (entityData, caseData) => {
    if (entityData !== undefined) {
      var projectId = entityData['csProjectNumber'] !== undefined ? entityData['csProjectNumber'].split('_') : '';
      if (projectId !== undefined) {
        entityData['csProjectNumber'] = projectId[1];
      }
      var cmpProjectId = entityData['projectNo'] === 'CMP' && entityData['cmpProjectID'] !== undefined
        ? entityData['cmpProjectID'].split('P')
        : '';
      if (cmpProjectId !== undefined) {
        entityData['cmpProjectID'] = cmpProjectId[1];
      }
      entityData['GdocsTerms'] = entityData['gdocsTerms']
      entityData['CaseID'] = caseData['caseId']
      entityData['caseId'] = caseData['id']
      return entityData;
    }
  }

  _setSelectedOptions = (entity) => {
    eapiClient('/entities/organisations/' + entity.entityId)
      .then(({ data, status }) => {
        this.setState({
          currentCase: this._setNewCaseProperties(data.responseData),
          formDisabled: false,
          entityId: data.responseData.id,
          gdocsTerms: "urn:hsbc:cmb:gdocs:cases:taxonomies:csGdocsTerms:newToGDocs",
          resetData: !this.state.resetData
        })

        // document.getElementById('CaseIDField').childNodes[1].childNodes[0].childNodes[7].childNodes[0].childNodes[0].disabled=true
        // if(document.getElementById("manual_case-msa_2011")){
        //   setElementAttributes(document.getElementById("manual_case-msa_2011"),{disabled:true})
        // }


        eapiClient('/cases/organisations/' + data.responseData.id + '/clientsphere-cases')
          .then(({ data, status }) => {
            let history = data.responseData;
            history.forEach(row => {
              row['caseOwner'] = row['caseOwner'].name
            });
            this.setState({ serviceHistory: Array.isArray(history) ? history : [] })
          });
      })
  }

  _setNewCaseProperties = (entity) => {
    if (entity !== undefined) {
      entity['financialInstitution'] = "";
      entity['businessSegment'] = "";
      entity['glcmImplementation'] = "";
      entity['projectNo'] = "";
      entity['csProjectNumber'] = "";
      entity['cmpProjectID'] = "";
      entity['CaseRecordType'] = this.state.formData.CaseRecordType;
      return entity;
    }
  }

  _onCreateNewEntity = (newEntity) => {
    console.log("TEST");
    this.setState({
      formDisabled: false,
      gdocsTerms: "urn:hsbc:cmb:gdocs:cases:taxonomies:csGdocsTerms:newToGDocs",
      currentCase: undefined,
      CreateNewToggle: !this.state.CreateNewToggle,
      entityId: undefined,
      serviceHistory: [],
      formData: {
        CaseID: this.state.formData['CaseID'],
        CaseRecordType: this.state.formData['CaseRecordType']
      },
      registeredName: newEntity
    }, () => {
      console.log(this.state, 'dealersOverallTotal1');
    });
  }

  renderFormGroups() {
    let formData = this.state.formData, mode = "";

    if (this.state.currentCase !== undefined) {
      formData = this.state.currentCase
      mode = "edit"
    }
    const properties = {
      formData,
      registeredName: this.state.registeredName,
      GdocsTerms: this.state.gdocsTerms,
      CaseID: this.state.formData.CaseID,
      editType: 'add-manual-case-basic-details',
      pathname: this.props.history.location.pathname
    };
    if (this.props.formJson !== undefined && this.props.formJson.aemform_ManualCaseBasicDetail !== undefined) {
      return (
        <Dynamicform
          mode={mode}
          properties={properties}
          url={FORM_REFS[this.props.formJson.aemform_ManualCaseBasicDetail.formRef]}
          hideButtons={false}
          routingFlag={false}
          saveButton={true}
          displayError={this.state.errMsg}
          CreateNewToggle={this.state.CreateNewToggle}
          serviceHistory={this.state.serviceHistory}
          flagCheck={this.state.flag}
          getFormData={this.getFormData}
          ResetForm={this.state.ResetForm}
          CaseRecordToggle={this.state.CaseRecordToggle}
          reload={this.state.reload}
          searchBoxDisabled={this.state.searchBoxDisabled}
          resetData={this.state.resetData}
          onCheckAvailability={this._onCheckAvailability}
          onReset={this._onReset}
          onSearch={this._onSearch}
          resetCaseID={this.resetCaseID}
          checkForConflictsStatus={false}
          onCreateNewEntity={this._onCreateNewEntity}
          setSelectedOptions={this._setSelectedOptions}
          onFormSubmit={this.onFormBasicDetail}
          onFormCancel={this.onFormCancel}
          disableSubmitOnClick={false}
          resetDisable={true}
          formDisabled={this.state.formDisabled}
          lang={this.props.lang.currentLang.lang}
          translatedData={this.props.lang.translatedData}
          flag={this.props.lang.currentLangFlag.flag}
          msaCases={this.props.msaCases}
          handleMsaCases={this.props.handleMsaCases}
          setFormRandomIdx={(value) => this.setState({ formRandomIdx: value })}
          isTnC={this.state.formDisabled}
        />
      );
    }
  }

  translations = (word) => {
    return Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }

  render() {
    const containerCss = classnames("create-new-manual-case", {
      "padding-40": !this.props.history.location.pathname.includes("/admin-panel/")
    });
    return (
      <div className={containerCss}>
        <div className="form-container">
          {this.renderFormGroups()}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, props) => {
  return {
    lang: state.lang,
    owningCase: electOwningCase(state.newManualCase),
    case: state.newManualCase
  }
}


const mapDispatchToProps = dispatch => {
  return {
    newManualCase: newCase => {
      dispatch(newManualCase(newCase))
    },
    setDarkTitleCurrentCase: (...args) => {
      dispatch(setDarkTitleCurrentCase(...args))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(BasicDetails);



// WEBPACK FOOTER //
// ./src/components/Admin/CaseBody/SubComp/BasicDetails.js